const Skill = (props) => {
    return ( 
        <div className="skills" onClick={props.handleClick}>
            <div className="skill-title"> 
                <img src={`images/skillstec/${props.logo}`} alt={`Logo ${props.title}`} />
                {props.title}
            </div>
            <div className="skill-info">
                <div className="content" dangerouslySetInnerHTML={{__html: props.content}} />
            </div>
        </div>
     );
}
 
export default Skill;